@let isStocks = widget()?.assetClass === 'us_equity';
@let activeType = widget()?.settings?.options?.activeType;

@if (isStocks) {
	<app-dropdown-columns-orders-stocks [widget]="widget()" />
} @else if (!isStocks && activeType === optionOrderTypeEnum.ORDERS) {
	<app-dropdown-columns-orders-options [widget]="widget()" />
} @else if (!isStocks && activeType === optionOrderTypeEnum.POST_TRADING) {
	<app-dropdown-columns-orders-post-trading [widget]="widget()" />
}
